'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentsListResponseItem(id, essentialInfo, version, createdBy, createdAt, receivingOrganization, totalAmount) {
  this.wB = null;
  this.Kw = null;
  this.Xp = 0;
  this.Xm = null;
  this.Kv = null;
  this.Xn = null;
  this.Xo = null;
  this.wB = id;
  this.Kw = essentialInfo;
  this.Xp = version;
  this.Xm = createdBy;
  this.Kv = createdAt;
  this.Xn = receivingOrganization;
  this.Xo = totalAmount;
}
export { $c_Lapp_api_DocumentsListResponseItem as $c_Lapp_api_DocumentsListResponseItem };
$p = $c_Lapp_api_DocumentsListResponseItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentsListResponseItem;
/** @constructor */
function $h_Lapp_api_DocumentsListResponseItem() {
}
export { $h_Lapp_api_DocumentsListResponseItem as $h_Lapp_api_DocumentsListResponseItem };
$h_Lapp_api_DocumentsListResponseItem.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentsListResponseItem)) {
    var x = this.wB;
    var x$2 = x$0.wB;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Kw;
      var x$4 = x$0.Kw;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.Xp === x$0.Xp))) {
      var x$5 = this.Xm;
      var x$6 = x$0.Xm;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Kv;
      var x$8 = x$0.Kv;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Xn === x$0.Xn))) {
      var x$9 = this.Xo;
      var x$10 = x$0.Xo;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 7;
});
$p.t = (function() {
  return "DocumentsListResponseItem";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.wB;
      break;
    }
    case 1: {
      return this.Kw;
      break;
    }
    case 2: {
      return this.Xp;
      break;
    }
    case 3: {
      return this.Xm;
      break;
    }
    case 4: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime(this.Kv);
      break;
    }
    case 5: {
      return this.Xn;
      break;
    }
    case 6: {
      return this.Xo;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "essentialInfo";
      break;
    }
    case 2: {
      return "version";
      break;
    }
    case 3: {
      return "createdBy";
      break;
    }
    case 4: {
      return "createdAt";
      break;
    }
    case 5: {
      return "receivingOrganization";
      break;
    }
    case 6: {
      return "totalAmount";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_DocumentsListResponseItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.is)));
}
export { $isArrayOf_Lapp_api_DocumentsListResponseItem as $isArrayOf_Lapp_api_DocumentsListResponseItem };
var $d_Lapp_api_DocumentsListResponseItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentsListResponseItem, "app.api.DocumentsListResponseItem", ({
  is: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentsListResponseItem as $d_Lapp_api_DocumentsListResponseItem };
//# sourceMappingURL=app.api.-Documents-List-Response-Item.js.map
